import { Bone } from "../../Component/MiscComponent/PrimitiveComponent";

// Skeleton blocks Component
export const SkelCard = ({ children, style={} }) => (
<div className="card" style={style}>
    <div className="card-body">{children}</div>
</div>
);

export const DashSkel = () => (
<div style={{ display:"flex", flexDirection:"column", gap:20 }}>
    <div className="hero-banner" style={{ minHeight:110, background:"var(--surface3)" }}>
        <div className="hero-content flex items-center justify-between wrap gap-3">
            <div style={{ display:"flex", flexDirection:"column", gap:8, flex:1 }}>
                <Bone w={90} h={11} />
                <Bone w={200} h={26} r={6} />
                <Bone w={150} h={11} />
            </div>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:8 }}>
                <Bone w={130} h={30} r={99} />
                <Bone w={100} h={18} r={99} />
            </div>
        </div>
    </div>
    <div className="col-4">
        {[0,1,2,3].map(i=>(
        <SkelCard key={i}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:10 }}>
                <Bone w={36} h={36} r={99} />
                <Bone w={80} h={11} />
                <Bone w={60} h={20} r={6} />
            </div>
        </SkelCard>
        ))}
    </div>
    <div className="grid-7-5">
        <SkelCard>
            <Bone w={140} h={11} style={{ marginBottom:14 }} />
            <div className="flex justify-between items-center" style={{ marginBottom:14 }}>
                <div style={{ display:"flex", flexDirection:"column", gap:6, flex:1 }}>
                    <Bone w="65%" h={18} r={5} />
                    <Bone w="40%" h={11} />
                </div>
                <Bone w={80} h={26} r={99} />
            </div>
            <Bone h={8} r={99} style={{ marginBottom:6 }} />
            <div className="flex justify-between" style={{ marginBottom:14 }}>
                <Bone w={70} h={10} />
                <Bone w={100} h={10} />
            </div>
            <div className="col-2">
                {[0,1].map(i=><div key={i} style={{ background:"var(--surface2)", borderRadius:10, padding:14 }}>
                    <Bone w="55%" h={11} style={{ marginBottom:6 }} />
                    <Bone w="75%" h={18} r={5} />
                </div>)}
            </div>
        </SkelCard>
        <SkelCard>
            <Bone w={160} h={11} style={{ marginBottom:14 }} />
            {[0,1,2].map(i=>(
            <div key={i} className="va-row" style={{ marginBottom:8 }}>
                <div className="flex items-center gap-2">
                    <Bone w={28} h={28} r={99} />
                    <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
                        <Bone w={80} h={11} />
                        <Bone w={120} h={13} />
                    </div>
                </div>
                <Bone w={26} h={26} r={6} />
            </div>
            ))}
            <Bone h={38} r={12} style={{ marginTop:8 }} />
        </SkelCard>
    </div>
</div>
);

export const BillSkel = () => (
<div style={{ display:"flex", flexDirection:"column", gap:20 }}>
    {/* Hero */}
    <div style={{ borderRadius:20, padding:"28px 32px", background:"var(--surface3)", minHeight:110 }}>
        <div className="flex justify-between items-center wrap gap-3">
            <div style={{ display:"flex", flexDirection:"column", gap:8, flex:1 }}>
                <div className="flex items-center gap-2">
                    <Bone w={140} h={24} r={99} />
                    <Bone w={180} h={12} r={4} />
                </div>
                <Bone w={220} h={22} r={6} />
                <Bone w={140} h={12} r={4} />
            </div>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:8 }}>
                <Bone w={60} h={11} r={4} />
                <Bone w={150} h={36} r={6} />
                <div className="flex items-center gap-2">
                    <Bone w={90} h={24} r={99} />
                    <Bone w={110} h={12} r={4} />
                </div>
            </div>
        </div>
    </div>
    {/* Progress card (INV) or date tiles (PSB) */}
    <SkelCard>
        <div className="flex justify-between items-center" style={{ marginBottom:16 }}>
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                <Bone w={100} h={11} />
                <div className="flex items-center gap-2">
                    <Bone w={110} h={22} r={99} />
                    <Bone w={20} h={14} />
                    <Bone w={110} h={22} r={99} />
                </div>
            </div>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}>
                <Bone w={70} h={11} />
                <Bone w={80} h={36} r={6} />
            </div>
        </div>
        <Bone h={12} r={99} style={{ marginBottom:6 }} />
        <div className="flex justify-between">
            <Bone w={80} h={11} />
            <Bone w={100} h={11} />
            <Bone w={80} h={11} />
        </div>
    </SkelCard>
    {/* 3-col grid */}
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
        <SkelCard style={{ gridColumn:"span 2" }}>
            <Bone w={100} h={14} r={5} style={{ marginBottom:14 }} />
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 32px" }}>
                {[0,1,2,3,4].map(i=>(
                <div key={i} className="flex justify-between"
                    style={{ padding:"9px 0", borderBottom:"1px solid var(--border)" }}>
                    <Bone w={`${45+(i%2)*15}%`} h={12} />
                    <Bone w="20%" h={12} />
                </div>
                ))}
            </div>
            <div className="flex justify-between" style={{ padding:"14px 0 0" }}>
                <Bone w="30%" h={16} r={4} />
                <Bone w="25%" h={22} r={4} />
            </div>
        </SkelCard>
        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
            <SkelCard>
                <Bone w={90} h={11} style={{ marginBottom:12 }} />
                <div className="flex justify-between" style={{ paddingBottom:14 }}>
                    {[0,1].map(j=><div key={j}
                        style={{ textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", gap:6 }}>
                        <Bone w={55} h={11} />
                        <Bone w={70} h={28} r={5} />
                    </div>)}
                </div>
                <Bone h={1} style={{ marginBottom:12 }} />
                {[0,1].map(i=><div key={i} className="flex justify-between" style={{ marginBottom:8 }}>
                    <Bone w="38%" h={12} />
                    <Bone w="48%" h={12} />
                </div>)}
            </SkelCard>
            <SkelCard>
                <Bone w={120} h={11} style={{ marginBottom:12 }} />
                <div className="va-row" style={{ marginBottom:8 }}>
                    <div className="flex items-center gap-2">
                        <Bone w={26} h={26} r={99} />
                        <div style={{ display:"flex",flexDirection:"column",gap:5 }}>
                            <Bone w={80} h={11} />
                            <Bone w={120} h={13} />
                        </div>
                    </div>
                    <Bone w={26} h={26} r={6} />
                </div>
            </SkelCard>
        </div>
    </div>
</div>
);

export const HistSkel = () => (
<div style={{ display:"flex", flexDirection:"column", gap:20 }}>
    <div>
        <Bone w={190} h={20} r={5} style={{ marginBottom:4 }} />
        <Bone w={240} h={12} r={4} />
    </div>
    <div className="grid-7-5" style={{ gridTemplateColumns:"5fr 7fr" }}>
        <SkelCard style={{ padding:0, overflow:"hidden" }}>
            {[0,1,2,3].map(i=>(
            <div key={i} style={{ padding:"16px 18px", borderBottom:"1px solid var(--border)" }}>
                <div className="flex justify-between items-center gap-2">
                    <div style={{ display:"flex", flexDirection:"column", gap:6, flex:1 }}>
                        <Bone w="70%" h={13} r={4} />
                        <Bone w="45%" h={10} r={4} />
                    </div>
                    <Bone w={68} h={24} r={99} />
                </div>
            </div>
            ))}
        </SkelCard>
        <SkelCard>
            <Bone w={160} h={16} r={5} style={{ marginBottom:6 }} />
            <Bone w={250} h={11} r={4} style={{ marginBottom:20 }} />
            <div className="col-2">
                {Array.from({length:10}).map((_,i)=>(
                <div key={i}>
                    <Bone w="50%" h={10} style={{ marginBottom:5 }} />
                    <Bone w="75%" h={13} r={4} />
                </div>
                ))}
            </div>
            <Bone w={80} h={26} r={99} style={{ marginTop:16 }} />
        </SkelCard>
    </div>
</div>
);

export const ProfileSkel = () => (
<div style={{ display:"flex", flexDirection:"column", gap:20 }}>
    <div>
        <Bone w={140} h={20} r={5} style={{ marginBottom:4 }} />
        <Bone w={230} h={12} r={4} />
    </div>
    <div className="grid-7-5">
        <SkelCard>
            <div className="flex items-center gap-3" style={{ marginBottom:20 }}>
                <Bone w={56} h={56} r={16} />
                <div style={{ display:"flex",flexDirection:"column",gap:8 }}>
                    <Bone w={150} h={18} r={5} />
                    <Bone w={70} h={22} r={99} />
                </div>
            </div>
            {Array.from({length:6}).map((_,i)=>(
            <div key={i} className="flex justify-between" style={{ marginBottom:10 }}>
                <Bone w="38%" h={12} />
                <Bone w="52%" h={12} />
            </div>
            ))}
        </SkelCard>
        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
            {[6,4].map((rows,ci)=>(
            <SkelCard key={ci}>
                <Bone w={140} h={11} style={{ marginBottom:14 }} />
                {Array.from({length:rows}).map((_,ri)=>(
                <div key={ri} className="flex justify-between" style={{ marginBottom:10 }}>
                    <Bone w="38%" h={12} />
                    <Bone w="52%" h={12} />
                </div>
                ))}
            </SkelCard>
            ))}
        </div>
    </div>
</div>
);

export const SidebarSkel = () => (
<>
    <div className="flex items-center gap-2"
        style={{ marginBottom:20, paddingBottom:16, borderBottom:"1px solid var(--border)" }}>
        <Bone w={36} h={36} r={10} />
        <div style={{ flex:1, display:"flex", flexDirection:"column", gap:6 }}>
            <Bone w="60%" h={12} />
            <Bone w="45%" h={10} />
        </div>
    </div>
    <div className="user-chip" style={{ marginBottom:12 }}>
        <Bone w={40} h={40} r={12} />
        <div style={{ flex:1, display:"flex", flexDirection:"column", gap:6 }}>
            <Bone w="65%" h={12} />
            <Bone w="80%" h={10} />
        </div>
    </div>
    <div
        style={{ background:"var(--surface2)", borderRadius:10, padding:12, marginBottom:12, border:"1px solid var(--border)" }}>
        <Bone w="50%" h={10} style={{ marginBottom:8 }} />
        <Bone h={30} r={8} />
    </div>
    {[0,1,2,3].map(i=>(
    <div key={i} className="flex items-center gap-3" style={{ padding:"10px 12px", marginBottom:2 }}>
        <Bone w={24} h={24} r={6} />
        <Bone w="60%" h={12} />
    </div>
    ))}
</>
);

export const HeaderSkel = () => (
<div className="flex items-center justify-between" style={{ flex:1 }}>
    <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
        <Bone w={150} h={16} r={5} />
        <Bone w={210} h={11} r={4} />
    </div>
    <Bone w={40} h={40} r={12} />
</div>
);

export const SKELS = {
    dashboard: <DashSkel />,
    billing: <BillSkel />,
    history: <HistSkel />,
    profile: <ProfileSkel />
};